import { SizeProps } from './size';
import { ArrayToType } from '../utils';

export const FontFamilyArray = [
  'primary',
  'times',
  'arial',
  'tahoma',
  'helvetica',
  'georgia',
  'aeonikLight',
  'aeonikRegular',
  'aeonikBold',
] as const;
export type FontFamilyProps = ArrayToType<typeof FontFamilyArray>;
export type FontWeightProps = 'light' | 'normal' | 'medium' | 'semiBold' | 'bold' | 300 | 400 | 500 | 600 | 700;

export interface FontProps {
  family: { [key in FontFamilyProps]: string };
  weight: { [key in FontWeightProps]?: number };
  size: { [key in SizeProps]: number };
  lineHeight: { [key in SizeProps]: number };
}

export const font: FontProps = {
  family: {
    primary: "'Inter', sans-serif",
    times: "'Times New Roman', serif",
    georgia: "'Georgia', serif",
    tahoma: "'Tahoma', sans-serif",
    helvetica: "'Helvetica', sans-serif",
    arial: "'Arial', sans-serif",
    aeonikLight: 'Aeonik-Light',
    aeonikRegular: 'Aeonik-Regular',
    aeonikBold: 'Aeonik-Bold',
  },
  weight: {
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  size: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 24,
    'ico-xs': 12,
  },
  lineHeight: {
    xs: 18,
    sm: 20,
    md: 22,
    lg: 24,
    xl: 26,
    xxl: 28,
    'ico-xs': 16,
  },
};
